import Router from 'next/router';
import { useCallback } from 'react';

import { type WorkspaceAgentCommentPill } from '~/components/v2/components/workspace/workspace-agent-panel/utils/toWorkspaceAgentCommentPillFromGetComment';
import { QueryParamNames } from '~/constants/search';
import { useGoToPrivateAssetPage } from '~/hooks/useGoToPrivateAssetPage';
import { getClipIdFromPath } from '~/utils/PathUtils';

export type { WorkspaceAgentCommentPill };

/**
 * Opens the clip version a comment pill cites and focuses its discussion in the asset modal
 * comments tab. Reuses the same `discussionId` query param as comment notifications.
 */
export const useOpenWorkspaceAgentCommentPill = () => {
  const { goToAssetPage } = useGoToPrivateAssetPage();

  const openCommentPill = useCallback(
    (pill: WorkspaceAgentCommentPill) => {
      const clipId = pill.versionId;
      const currentClipId = getClipIdFromPath(Router.asPath);

      goToAssetPage({
        asset: { id: clipId },
        isAssetModalAlreadyOpen: Boolean(currentClipId),
        query: {
          [QueryParamNames.amTab]: 'comments',
          [QueryParamNames.discussionId]: [pill.discussionId],
        },
        trackLocation: 'comments-click',
      });
    },
    [goToAssetPage],
  );

  return { openCommentPill };
};
